import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { CustomInputMappingField, getCalculatedWithUnits, getUnitsOfcalculateField } from '@tuqqi/common';
import { ErrorIcon } from './ErrorIcon';
import CalculatedFieldTooltip from './CalculationTooltip'
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface INumber {
    field: CustomInputMappingField,
    value: string,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    valueError: {
        color: 'rgba(0, 0, 0, 0.42)',
        display: 'flex',
        alignItems: 'center'
    },
    valueText: {
        color: 'rgba(0, 0, 0, 0.42)'
    },
    valueTextPresented: {
        color: '#202124',
    },
    valueTextLearn: {
        color: '#7B4FF0',
        cursor: 'pointer'
    },
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
      //@ts-ignore
      inputLabel: theme.inputLabel
}))


export default function CalculationField({ field, value,isRtl }: INumber) {
    const classes = useStyles();

    const [val, error, isValidValue] = useMemo(() => {
        let val = value
        let isError = value === 'error'
        const isCalculated = !(!value && value !== '0')
        
        const isValidValue = !!isCalculated && !isError && !!value
        if(!isCalculated) {
            val = 'No calculated yet'
        }
        if(val === 'error') {
            val = "There is an error."
        }
        return [val, isError, isValidValue]
    }, [value])

    const units = useMemo(() => getUnitsOfcalculateField(field), [field])

    const style = { 
        direction: isRtl ? 'rtl' : 'ltr',
        textAlign: isRtl ? 'right' : 'left' 
    } as CSSProperties

    const goLink = () => {
        window.open('https://help.tuqqi.com/en/articles/6560732-typical-errors-in-calculated-fields', '_blank')
    }

    const renderValue = () => {
        let comp = null
        if(!!error) {
            comp = <div style={style} className={classes.valueError}>
                <ErrorIcon />
                <div style={{marginRight: 4, marginLeft: 8}} className={classes.valueText}>{val}</div>
                <div onClick={goLink} className={classes.valueTextLearn}>{"Learn more"}</div>
            </div>
            return <CalculatedFieldTooltip component={comp} />
        }
        comp = <div style={style} className={`${classes.valueText} ${isValidValue ? classes.valueTextPresented : ''}`}>{`${isValidValue ? getCalculatedWithUnits(val, units) : ''}`}</div>
        return <CalculatedFieldTooltip component={comp} />
    }

    return(
        <>
          <InputLabel 
           style={{ 
            direction: isRtl ? 'rtl' : 'ltr',
            textAlign: isRtl ? 'right' : 'left' 
        }} 
        htmlFor={field.sourceField} className={classes.inputLabel}>{field.fieldName}</InputLabel>
          {renderValue()}
        </>
    )
}